
export const SET_ADMIN_PERMISSION = "SET_ADMIN_PERMISSION";
export const SET_ADMIN_INFORMATION = "SET_ADMIN_INFORMATION";
export const SET_ADMIN_ROLE_ID = "SET_ADMIN_ROLE_ID";